import React from 'react';
import PropTypes from 'prop-types';
import Avatar, { AVATAR_SIZES } from '../../Avatar';
import { StyledTypography } from './User.styles';

export const User = (props) => {
  let value;
  if (typeof props === 'string') {
    value = props;
  } else if (typeof props === 'object') {
    if (typeof props.cell.value === 'string') {
      value = props.cell.value;
    } else {
      value = Object.values(props.cell.value ?? '').join(' ');
    }
  } else {
    // eslint-disable-next-line no-console
    console.error('Value provided for `Text` cell component is not accepted');
  }

  return (
    <StyledTypography component="div">
      <Avatar size={AVATAR_SIZES.SMALL} name={value} />
      {value}
    </StyledTypography>
  );
};

User.propTypes = {
  cell: PropTypes.object,
};
